import React from 'react'
import Sidebar, { SidebarItem } from '../Sidebar/Sidebar'
import HelpNav from '../../../Configurators/components/HelpNav'
import SubTotal from '../SubTotal'
interface LeftNavProps {
  sidebarItems: SidebarItem[]
  productName: string
  count?: number | null
  price?: string | null
  steps?: string | null
  activeStep: number
  subtotal?: boolean | null
  productDetails?: any
  geneSearchError?: boolean | null
}

enum Products {
  KicqStart = 'kicqstartProbe',
  selectAssays = 'selectAssays',
  SiRNA = 'sirna',
  KicqstartPrimers = 'kicqstartPrimers',
  SelectPrimers = 'selectprimers',
}

const LeftNav: React.FC<LeftNavProps> = ({
  sidebarItems,
  productName,
  count,
  price,
  steps,
  activeStep,
  subtotal,
  productDetails,
  geneSearchError,
}) => {
  return (
    <>
      <Sidebar
        items={sidebarItems}
        activeStep={activeStep}
        productName={productName}
      />
      {(Products.KicqStart === productName &&
        Products.selectAssays === steps &&
        !geneSearchError &&
        subtotal) ||
      (Products.SiRNA === productName &&
        Products.selectAssays === steps &&
        !geneSearchError &&
        subtotal) ||
      (Products.KicqstartPrimers === productName &&
        Products.SelectPrimers === steps &&
        !geneSearchError &&
        subtotal) ? (
        <SubTotal count={count} price={price} />
      ) : (
        ''
      )}
      <HelpNav
        country={productDetails.countryCode}
        product={productDetails.productType}
      />
    </>
  )
}
export default LeftNav
